module.exports = __webpack_public_path__ + "img/Laser.535f4164.svg";